const STORAGE_KEY = 'p3portal-staff-view-as'

function readStoredViewAs() {
  try {
    const value = window.sessionStorage.getItem(STORAGE_KEY)
    if (!value) return null
    const email = String(value).trim().toLowerCase()
    return email || null
  } catch (_) {
    return null
  }
}

let viewAsEmail = typeof window !== 'undefined' ? readStoredViewAs() : null

function persistViewAs(email) {
  try {
    if (email) window.sessionStorage.setItem(STORAGE_KEY, email)
    else window.sessionStorage.removeItem(STORAGE_KEY)
  } catch (_) {}
}

export function getStaffViewAsEmail() {
  return viewAsEmail
}

export function setStaffViewAsEmail(email) {
  const next = email ? String(email).trim().toLowerCase() : ''
  viewAsEmail = next || null
  persistViewAs(viewAsEmail)
}

export function clearStaffViewAs() {
  setStaffViewAsEmail(null)
}

export function appendStaffViewAsQuery(url) {
  if (!viewAsEmail) return url
  const separator = url.includes('?') ? '&' : '?'
  return `${url}${separator}viewAs=${encodeURIComponent(viewAsEmail)}`
}

export { STORAGE_KEY as STAFF_VIEW_AS_STORAGE_KEY }
